import { ChangeDetectorRef, Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MatDateFormats,
} from '@angular/material/core';
import {
  MatCalendar,
  MatCalendarHeader,
  MatDatepickerIntl,
} from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { startWith } from 'rxjs';

@Component({
    selector: 'calendar-header',
    imports: [MatButtonModule, MatIconModule],
    templateUrl: './calendar-header.component.html',
    styleUrl: './calendar-header.component.scss'
})
export class CalendarHeaderComponent<D> extends MatCalendarHeader<D> {
  private dateAdapter: DateAdapter<D>;

  private destroyRef = inject(DestroyRef);

  protected activeMonth: string = '';
  protected activeYear: string = '';

  constructor() {
    const intl = inject(MatDatepickerIntl);
    const calendar = inject<MatCalendar<D>>(MatCalendar);
    const dateAdapter = inject<DateAdapter<D>>(DateAdapter);
    const dateFormats = inject<MatDateFormats>(MAT_DATE_FORMATS, { optional: true });
    const changeDetectorRef = inject(ChangeDetectorRef);

    super(intl, calendar, dateAdapter, dateFormats, changeDetectorRef);
    this.dateAdapter = dateAdapter;

    this.calendar.stateChanges
      .pipe(startWith(null), takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.activeMonth =
          this.dateAdapter.getMonthNames('long')[
            this.dateAdapter.getMonth(this.calendar.activeDate)
          ];

        this.activeYear = this.dateAdapter
          .getYear(this.calendar.activeDate)
          .toString();
      });
  }

  protected onMonthClick() {
    this.calendar.currentView = 'year';
  }
  protected onYearClick() {
    this.calendar.currentView = 'multi-year';
  }
}
